import { Boxes } from "lucide-react";
import { EmptyState, PageHeader, Panel, RowsSkeleton, Tag } from "@/components/app/kit";
import { useFetch } from "@/hooks/useServerList";

export default function TenantModules() {
  const { data, loading } = useFetch("/t/modules");
  return (
    <div>
      <PageHeader eyebrow="Administration" title="Modules du cabinet" subtitle="Modules autorisés par l'administration de la plateforme pour votre cabinet. Pour en ajouter, contactez votre administrateur plateforme." />
      <Panel>
        {loading ? <RowsSkeleton /> : !data?.length ? <EmptyState icon={Boxes} title="Aucun module" /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {data.map((m) => (
              <div key={m.code} className="rounded-xl border border-slate-200 p-4" data-testid={`tenant-module-${m.code}`}>
                <div className="flex flex-wrap items-center gap-2">
                  <p className="font-semibold text-sm">{m.name}</p>
                  {m.is_core && <Tag tone="indigo">Socle</Tag>}
                  {!m.implemented && <Tag tone="gray">En développement</Tag>}
                </div>
                <p className="text-xs text-slate-500 mt-1">{m.description}</p>
              </div>
            ))}
          </div>
        )}
      </Panel>
    </div>
  );
}
